// export const BASE_URL = `http://172.16.25.208:8800/api/user`
// export const BASE_URL = `http://3.72.82.38:8000/api/user` // dev
// export const BASE_URL = `https://dev-backend-user-plastic.plasticherocoin.com/api/user` // dev
// export const BASE_URL = `http://172.16.25.245:8000/api/user` // dev
export const BASE_URL = `https://api-01-usr-bk.plasticherocoin.com/api/user` // live

export const CHECK_TRANSACTION_URL = `https://etherscan.io/tx/`
  